export const FRENCH_PHONE_REGEX = /^(?:0\d{9}|\+33\d{9})$/;

export const FRENCH_PHONE_INVALID_MESSAGE =
  "Veuillez saisir un numéro français valide (0… ou +33…).";

export function normalizeFrenchPhoneCandidate(value: string): string {
  return value.trim().replace(/[\s.-]/g, "");
}

/** Empty is valid; otherwise must be 0XXXXXXXXX or +33XXXXXXXXX after normalization. */
export function isOptionalFrenchPhoneValid(value: string): boolean {
  if (!value.trim()) return true;
  return FRENCH_PHONE_REGEX.test(normalizeFrenchPhoneCandidate(value));
}
